import { GROUP_TYPE } from "@home-health-notify/domain";
import { Tooltip } from "@mui/material";
import { getGroupStatusProperty } from "hhn-commons";
import { getAvatarSize, GROUP_AVATAR_SIZE } from "../utils/AvatarUtils";
import PatientHomeIcon from "./PatientHomeIcon";

interface PatientStatusImageProps {
  status: number;
  size?: GROUP_AVATAR_SIZE;
  testId?: string;
}

function PatientStatusImage({
  status,
  size = GROUP_AVATAR_SIZE.MEDIUM,
  testId,
}: PatientStatusImageProps) {
  const statusProperty = getGroupStatusProperty(status);
  const dimension = getAvatarSize(GROUP_TYPE.PATIENT, size);

  return (
    <Tooltip title={statusProperty.title} placement="top" arrow>
      <div style={{ marginRight: 10 }} data-testid={testId} aria-label={statusProperty.title}>
        <PatientHomeIcon size={dimension} status={status} />
      </div>
    </Tooltip>
  );
}

export default PatientStatusImage;
